module.exports = __webpack_public_path__ + "img/symbol_8.b9f6c3f1.png";